import script from "./DropdownItem.vue?vue&type=script&setup=true&lang=js"
export * from "./DropdownItem.vue?vue&type=script&setup=true&lang=js"

import "./DropdownItem.vue?vue&type=style&index=0&id=4f8ccc02&lang=scss&scoped=true"

import exportComponent from "/home/ubuntu/aos/aos-ats-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f8ccc02"]])

export default __exports__